import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RestService } from './crud/rest.service';

const AUTOCOMPLETION_URL = 'https://autocomplete.geocoder.ls.hereapi.com/6.2/suggest.json';
const GEOCODER_URL = 'https://geocoder.ls.hereapi.com/6.2/geocode.json';

@Injectable({
  providedIn: 'root'
})
export class HereJsService {

  key: string = environment?.here?.rest?.key || '';

  constructor(
    private rest: RestService
  ) {
  }








  
  
  public coords: any = JSON.parse(window.localStorage.getItem('coords')) || {latitude:32.715736,longitude:-117.161087};
  
  async predict(q: string) {
    let r: any = [{description: 'No results'}];
    let s: any = await this.rest.get(AUTOCOMPLETION_URL,
    'query=' +  encodeURIComponent(q) +   // The search text which is the basis of the query
    '&maxresults=3' +  // The upper limit the for number of suggestions to be included // in the response.  Default is set to 5.
    `&prox=${this.coords.latitude},${this.coords.longitude},5000` +
    '&country=USA' +
    '&apikey=' + this.key,
    '?');
    if(s){
      let d = JSON.parse(s.data);
      r = d.suggestions;
    }
    return r;
  }

  address(r) {
    this.geocode(r);
    console.log(r);
    return {
      ...(r.address.houseNumber || r.address.street)?
      {line1: ((r.address.houseNumber||'') + ' ' +
      (r.address.street||''))}:null,
      line2: null,
      city: r.address.city || null,
      state: r.address.state || null,
      country: r.countryCode || null,
      postal_code: r.address.postalCode || null
    }
  }

  async geocode(locId) {
    let r: any = {}; locId = locId?.locationId||locId;
    let c: any = await this.rest.get(GEOCODER_URL,
    'locationid=' + locId/*encodeURIComponent(r)*/ +   // The search text which is the basis of the query
    '&jsonattributes=1' +  // The upper limit the for number of suggestions to be included // in the response.  Default is set to 5.
    '&gen=9' +
    '&apiKey=' + this.key,
    '?');
    if(c){
      let d = JSON.parse(c.data);
      r = d?.response?.view[0]?.result[0]?.location||"No data";
    }
    console.log(r);
    return r
  }
}
